namespace $.$$ {

export class $shm_hitalama_map_method_source_view extends $.$shm_hitalama_map_method_source_view {

		@ $mol_mem
		runtime() {
			return this.map().method_runtime()
		}

		@ $mol_mem
		source( next?: string ): string {
			return next ?? this.runtime().source().source()
		}

		@ $mol_action
		export() {
			this.source( this.runtime().source().source() )
		}

		@ $mol_action
		import() {
			this.runtime().source().sync_from_source( this.source() )
		}

		@ $mol_action
		layout_methods() {
			this.runtime().method_widgets_layout()
		}

	}

}
